import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationStatus = ({ status }) => {
  if (status === 'verified') {
    return (
      <div className="mb-6 p-6 bg-success/10 border border-success rounded-lg text-center animate-fade-in">
        <div className="flex justify-center mb-3">
          <div className="bg-success rounded-full p-3">
            <Icon name="CheckCircle" size={32} className="text-white" />
          </div>
        </div>
        <h3 className="text-lg font-semibold text-success mb-1">Email Verified!</h3>
        <p className="text-sm text-muted-foreground">Redirecting to dashboard...</p>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="mb-6 p-4 bg-error/10 border border-error rounded-lg text-center">
        <div className="flex justify-center mb-2">
          <Icon name="XCircle" size={24} className="text-error" />
        </div>
        <p className="text-sm font-semibold text-error">Verification Failed</p>
      </div>
    );
  }

  return null;
};

export default VerificationStatus;